export default __webpack_public_path__ + "static/NewsImage3-23b9651b869f0780d1bce9aad7388123.jpg";